(function() {

    var timer = null;

    $(document)
        .on('change', 'select[data-autosubmit], input[data-datepicker][data-autosubmit]', function() {
            $(this).closest('form').submit();
        })
        .on('keyup', 'input[data-autosubmit], textarea[data-autosubmit]', function() {
            clearTimeout(timer);
            var $this = $(this);
            timer = setTimeout(function() {
                $this.closest('form').submit();
            }, 1000);
        });
})();